import { useContext, useMemo } from "react";
import { LocationControlSettingsContext } from "@contexts/location_control_settings_context.ts";
import LocationControl from "@grnhse/location-control";

export const useLocationControl = () => {
  const { apiKey, provider, baseUrl } = useContext(LocationControlSettingsContext);

  return useMemo(() => {
    return new LocationControl({ apiKey, provider, baseUrl });
  }, [apiKey, provider, baseUrl]);
};
